import { fetchFromOldApi } from '~/services/Http';

import { IFormInput } from '../useHomeContact';

export type EmpHomeContactType = {
  fEmpPhoneHome: string;
  fEmpEmailHome: string;
  fEmpStreetAddress1?: string;
  fEmpStreetAddress2: string;
  fEmpPostalCode?: string;
  fEmpState: string;
  fEmpCity?: string;
  fEmpCountry?: string;
};

export interface Country {
  code: string;
  name: string;
  description?: string;
}

export const putEmpHomeContactData = async (
  json: IFormInput,
  iEmpId: number,
) => {
  return await fetchFromOldApi('/form/employee/' + iEmpId + '/home', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(json),
  }).then((r) => r.json());
};

export const deleteEmpHomeContactData = async (iEmpId: number) => {
  return await fetchFromOldApi('/json/employee/' + iEmpId + '/home', {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
  }).then((r) => r.json());
};
